import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import { cloneDeep } from 'lodash';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import { SelectChangeEvent } from '@mui/material';
import { Typography } from '@mui/material';
import { SelectComponent, TextComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import TemplatizedFieldComponent, { TemplatizedValue, getTemplatizedValue } from './templatizedFieldComponent';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}

const GenerateWebAuthnCredentialsExistUI = ({
  componentData,
  closeGritComponent,
  setUnsavedChanges,
}: componentProps) => {
  const configData = jsonComponentsConfig.webAuthnAuthentication.data;
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims, modifiedTemplatizations, setModifiedTemplatizations } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const classes = jsonEditorStyles();

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || !modifiedData['existsClaim'] || (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <div>
      <FormControl required sx={{ m: 1, minWidth: 600 }}>
        <div className={classes.flexRow}>
          <TemplatizedFieldComponent
            modifiedTemplatizations={modifiedTemplatizations}
            setModifiedTemplatizations={setModifiedTemplatizations}
            data={{
              fieldPath: 'contentDefinition',
              label: configData['contentDefinition']['displayName'],
              style: { margin: 1, width: 600 },
              value: getTemplatizedValue(modifiedData['contentDefinition']),
              variant: 'text'
            }}
            changeHandler={(e: TemplatizedValue) => {
              setModifiedData({ ...modifiedData, contentDefinition: { ...e } });
            }}
          />
        </div>
        <Typography variant="body1" sx={{ pt: 1 }}>
          Select claim to output boolean flag indicating the presence of user credentials usable for webAuthn login:
        </Typography>
        <div className={classes.flexRow} style={{ alignItems: 'center' }}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setModifiedData({
                ...modifiedData,
                ['existsClaim']: e.target.value,
              });
            }}
            data={{
              value: modifiedData.existsClaim ? modifiedData.existsClaim : '',
              label: 'Credential Existence Claim',
              required: true,
              style: { margin: 1, width: 250 },
              options: Object.keys(allClaims)
                .filter((c) => {
                  return allClaims[c]?.dataType === 'boolean';
                })
                .reduce((acc: OptionProps[], curVal: string) => {
                  return acc.concat({ label: curVal, value: curVal });
                }, [])
                .sort((a: OptionProps, b: OptionProps) => {
                  return a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1;
                }),
            }}
          />
        </div>
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(cloneDeep(modifiedData), modifiedTemplatizations);
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </FormControl>
    </div>
  );
};

export default GenerateWebAuthnCredentialsExistUI;
